import { bootstrapApplication } from '@angular/platform-browser';
import { provideZonelessChangeDetection } from '@angular/core';
import { AppComponent } from './app.component.js';

bootstrapApplication(AppComponent, {
  // The explorer is signal-driven throughout, so it needs no zone.
  providers: [provideZonelessChangeDetection()],
}).catch((error) => console.error(error));
